"use strict";

import _ from "lodash";
const some = _.some;
const orderBy = _.orderBy;

import classNames from "classnames";
import React, { Component, PropTypes } from "react";
import AutoForm from "react-auto-form";

import ControlClassRepository from ".\\ControlClassRepository";
import FormContext from ".\\FormContext";
import ComponentBase from ".\\ComponentBase";

import ErrorMessage from ".\\ErrorMessage";
import TextInput from ".\\TextInput";
import CaptchaInput from ".\\CaptchaInput";
import CountrySelectInput from ".\\CountrySelectInput";
import PhoneInput from ".\\PhoneInput";
import Submit from ".\\Submit";

ControlClassRepository.register("ErrorMessage", ErrorMessage);

ControlClassRepository.register("TextInput", TextInput);
ControlClassRepository.register("CaptchaInput", CaptchaInput);
ControlClassRepository.register("CountrySelectInput", CountrySelectInput);
ControlClassRepository.register("PhoneInput", PhoneInput);

ControlClassRepository.register("Submit", Submit);

/******************************************************************************
** ReactForm
*/

export default class ReactForm extends ComponentBase {

	static propTypes = {
		formKey: PropTypes.string.isRequired,
		targetContentKey: PropTypes.string.isRequired,
		defaultCountryIso2Code: PropTypes.string.isRequired,
		formDef: PropTypes.object.isRequired,
		modelState: PropTypes.object,
		adRollSegmentId: PropTypes.string,
		formFixedData: PropTypes.object,
	};

	constructor(props) {
		super(props);
		let formContext = new FormContext(this);
		this.formContext = formContext;
		this._onSubmit = this._onSubmit.bind(this);
		this._onTryAgainClick = this._onTryAgainClick.bind(this);
		let modelState = props.modelState || { InputStates: [] };
		let ctrlDefs = props.formDef.controls.map(function(ctrlDef, i) {
			if (typeof ctrlDef.displayOrder == "undefined")
				ctrlDef.displayOrder = 0;
			return ctrlDef;
		});
		ctrlDefs = orderBy(ctrlDefs, ["displayOrder"], ["asc"]);
		let controls = ctrlDefs.map(function(ctrlDef, i) {
			let component = ReactForm._createComponent(formContext, modelState.InputStates, ctrlDef, `ctrl_${i}`);
			return component;
		});

		this.state = Object.assign(this.state || {}, {
			formHtml: props.formHtml,
			actionUrl: "/umbraco/Surface/" + props.formDef.submitController + "/" + props.formDef.submitAction,
			clientId: "Form_" + props.formKey,
			currentCountryIso2Code: props.defaultCountryIso2Code,
			isError: false,
			retryOnError: false,
			isComplete: false,
			message: null,
			modelState: modelState,
			controls: controls
		});
	}

	static _createComponent(formContext, inputStates, ctrlDef, refId) {
		switch (ctrlDef.$type) {
			case "input":
			case "button":
				let component = ControlClassRepository.find(ctrlDef.controlType);
				if (typeof component == "undefined") {
					return (
							<ErrorMessage key={ctrlDef.name}>
								Control type "{ctrlDef.controlType}" for "{ctrlDef.$type}" category is not supported yet.
							</ErrorMessage>
						);
				}
				let inputState = _.find(inputStates, { Name: ctrlDef.name }) || { Value: ctrlDef.defaultValue };
				return React.createElement(component, {
					context: formContext,
					key: ctrlDef.name,
					name: ctrlDef.name,
					ref: refId,
					title: ctrlDef.title,
					showLabel: ctrlDef.showLabel,
					showPlaceholder: ctrlDef.showPlaceholder,
					isRequired: ctrlDef.isRequired,
					isRequiredMessage: ctrlDef.isRequiredMessage,
					validationExpression: ctrlDef.validationExpression,
					validationMessage: ctrlDef.validationMessage,
					containerClassNames: ctrlDef.containerClassNames,
					labelClassNames: ctrlDef.labelClassNames,
					inputClassNames: ctrlDef.inputClassNames,
					defaultValue: inputState.Value
				});
			default:
				return (
						<ErrorMessage key={ctrlDef.name}>
							Control category "{ctrlDef.$type}" is not supported yet.
						</ErrorMessage>
					);
		}
	}

	updateInputStates(inputStates) {
		let self = this;
		this.state.controls.map(function(control) {
			let ctrl = self.refs[control.ref];
			let inputState = _.find(inputStates, { Name: control.props.name });
			if (inputState) {
				ctrl.updateInputState(inputState);
			}
		});
	}
	/*
	componentDidUpdate() {
		if (typeof super.componentDidUpdate == "function")
			super.componentDidUpdate();
		$.validator.unobtrusive.parse(document);
	}
	*/

	render() {
		let controls = this.state.controls.slice(0);
		let textResources = this.props.formDef.textResources || {};
		if (this.state.isError) {
			if (this.state.isComplete || this.state.message.startsWith("Thank you")) {
				controls.push([
					(
						<div className="form__message form__message_error">
							<div className="form__message__wrapper">
								<p>{this.state.message}</p>
							</div>
						</div>
					)
				]);
			} else {
				controls.push([
					(
						<div className="form__message form__message_error">
							<div className="form__message__wrapper">
								<div className="form__message__title">{textResources.formFailTitle || "Fail!"}</div>
								<p>{this.state.message}</p>
								<a href="javascript:void(0)" onClick={this._onTryAgainClick} className="button">{textResources.formFailTryAgainButtonTitle || "Try again"}</a>
							</div>
						</div>
					)
				]);
			}
		}
		if (this.state.isComplete) {
			controls.push([
				(
					<div className="form__message form__message_success">
						<div className="form__message__wrapper">
							<div className="form__message__title">{textResources.formSuccessTitle || "Congratulation!"}</div>
							<div dangerouslySetInnerHTML={{__html: this.state.message}} />
						</div>
					</div>
				)
			]);
		}
		return (
				<div ref="topContainer" className={classNames("form", { "form_disabled form_state_loading": this.state.isAjaxLoading, "form_disabled": this.state.isError || this.state.isComplete })}>
					<div className="form__title">{this.props.formDef.title || textResources.defaultFormTitle || "SIGN UP TODAY!"}</div>
					{this.props.headerHtml &&
					<div className="form__text" dangerouslySetInnerHTML={{__html: this.props.headerHtml}} />
					}
					<AutoForm method="POST" className="form__wrapper" id={this.state.clientId} action={this.state.actionUrl} encType="multipart/form-data" onSubmit={this._onSubmit}>
						<input name="formKey" type="hidden" value={this.props.formKey} />
						<input name="contentKey" type="hidden" value={this.props.targetContentKey} />
						<input name="formDefName" type="hidden" value={this.props.formDef.name} />
						<input name="formData" type="hidden" />
						{controls}
					</AutoForm>
					{this.props.footerHtml &&
					<div className="form__text" dangerouslySetInnerHTML={{__html: this.props.footerHtml}} />
					}
				</div>
			);
	}

	_onTryAgainClick() {
		this.setState({
			isError: false,
			message: null,
		});
	}

	getData(url, onSuccess, onError) {
		let self = this;
		this.setState({ isAjaxLoading: true });
		$.ajax({
			type: "GET",
			//xhrFields: { withCredentials: true },
			//crossDomain: true,
			url: url,
			success: function(data) {
				if (typeof onSuccess == "function") {
					onSuccess(data);
				}
				self.setState({ isAjaxLoading: false });
			},
			error: function(xhr, err) {
				if (typeof onError == "function") {
					onError(err);
				}
				self.setState({
					isAjaxLoading: false,
					isError: true,
					message: err,
				});
			}
		});
	}

	postData(url, data, onSuccess, onError) {
		let self = this;
		this.setState({ isAjaxLoading: true });
		$.ajax({
			type: "POST",
			//xhrFields: { withCredentials: true },
			//crossDomain: true,
			url: url,
			dataType: "json",
			data: data,
			success: function(data) {
				if (typeof onSuccess == "function") {
					onSuccess(data);
				}
				self.setState({ isAjaxLoading: false });
			},
			error: function(xhr, err) {
				if (typeof onError == "function") {
					onError(err);
				}
				self.setState({
					isAjaxLoading: false,
					isError: true,
					message: err,
				});
			}
		});
	}

	isValid() {
		let self = this;
		let controls = this.props.formDef.controls.map(function(ctrlDef, i) {
			return self.refs[`ctrl_${i}`];
		});
		let isValidControls = controls.map(function(control) {
			return typeof control.isValid != "function"
				|| control.isValid();
		});
		let isValid = _.every(isValidControls, function(isValidControl) {
			return isValidControl;
		});
		return isValid;
	}

	_onSubmit(event, data) {
		event.preventDefault();
		let self = this;
		if (typeof this.props.formFixedData == "object") {
			data = Object.assign(data || {}, this.props.formFixedData);
		}
		if (this.isValid()) {
			this.postData(this.state.actionUrl, data, function (data) {
				if (data.success) {
					if (self.props.formDef.completeScript) {
						eval(self.props.formDef.completeScript);
					}
					if (self.props.adRollSegmentId) {
						try {
							__adroll.record_user({ "adroll_segments": self.props.adRollSegmentId });
						} catch (err) {
						}
					}
					if (data.redirectUrl) {
						setTimeout(function() {
							document.location.href = data.redirectUrl;
						}, 20000);
					}
					self.setState({
						isError: false,
						isComplete: true,
						message: data.message,
						modelState: data.modelState,
					});
					self.updateInputStates(data.modelState.InputStates);
				} else {
					if (data.modelState.IsValid) {
						self.setState({
							isError: true,
							isComplete: data.IsComplete || false,
							message: data.message,
							modelState: data.modelState
						});
						self.updateInputStates(data.modelState.InputStates);
					} else {
						self.setState({
							isError: false,
							isComplete: false,
							message: null,
							modelState: data.modelState
						});
						self.updateInputStates(data.modelState.InputStates);
					}
				}
			});
		}
	}
}



/** WEBPACK FOOTER **
 ** ./forms/ReactForm.jsx
 **/